'use strict';

/**
 * Model for the exports
 *
 * @category   Model
 * @module     Export
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoModel = require('base/Colido.Model');

var ExportModel = ColidoModel.extend({
    api: '/export',

    defaults: {
        state: 'waiting',
    },
});

module.exports = ExportModel;